import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watch } from "vue";
import { EChartsOption, init } from "echarts";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'BarChart',
  props: {
  className: {
    type: String,
    default: "chart",
  },
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "325px",
  },
  detail: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



onMounted(() => {
  // 获取dom，断言HTMLElement类型，否则会报错
  const chartEle: HTMLElement = document.getElementById(
    "chart3"
  ) as HTMLElement;
  watch(props, () => {
    showEchart();
  }),
    { immediate: true, deep: true };
  const chart = init(chartEle);
  const showEchart = () => {
    const option: EChartsOption = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      grid: {
        left: 40,
        right: 65,
        bottom: 20,
        top: 50,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: props.detail?.xtime_data,
        axisTick: {
          alignWithLabel: true,
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
      },
      yAxis: {
        axisTick: {
          show: false,
        },
      },
      legend: {
        data: [
          t("systemloadminute"),
          t("systemloadfiveminute"),
          t("systemloadquarterminute"),
        ],
      },
      series: [
        {
          name: t("systemloadminute"),
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#7265f9",
          },
          data: props.detail?.system_load_1,
        },
        {
          name: t("systemloadfiveminute"),
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#ffda00",
          },
          data: props.detail?.system_load_5,
          animationDuration: 2800,
        },
        {
          name: t("systemloadquarterminute"),
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#ff5636",
          },
          data: props.detail?.system_load_15,
          animationDuration: 2800,
        },
      ],
    };
    option && chart.setOption(option);
  };
  showEchart();
  window.addEventListener("resize", () => {
    chart.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "chart3",
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({ height: __props.height, width: __props.width })
  }, null, 6))
}
}

})